import { Contact, UserStatus } from './contact';

export interface IssuerSalesContactDetails {
  id?: string;
  issuerid: string;
  name: string;
  email: string;
  salesdesk?: string[];
  salesregion?: string[];
  role?: string;
  invitesentat?: string;
  optoutdocalert?: boolean;
}

export type IssuerSalesContact = IssuerSalesContactDetails & { id: string; issuername: string };

export type IssuerContactTableItem = IssuerSalesContact & {
  issuer: string;
  userStatus: UserStatus;
  cognitoUserId?: string;
  lastLogin?: string;
};

export enum IssuerUserRoles {
  SALES = 'Sales',
  MANAGER = 'Manager',
  COMPLIANCE = 'Compliance',
  LEGAL_APPROVER = 'Legal Approver',
}
